import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { extractFieldsFromSchema } from '@/utils/field-schema-helper'
import { formatDateTime, formatDateWithYear } from '@/utils/date-formatting'

interface Props {
  customData: Record<any, any> | null
  rootSchema: Record<any, any> | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldViewReadonlyCustomData',
  props: {
    customData: { default: null },
    rootSchema: { default: null }
  },
  setup(__props: any) {

const props = __props as { customData: Record<any, any> | null, rootSchema: Record<any, any> | null }



const schema = computed(() => {
  return props.rootSchema?.schema
})

const uiSchema = computed(() => {
  return props.rootSchema?.uiSchema
})

const customFields = computed(() => {
  const customFields: Record<any, any> = {}
  extractFieldsFromSchema(schema.value, uiSchema.value, customFields)
  return customFields
})

const locationHasCustomData = computed(() => {
  return Object.keys(customFields.value).length > 0
})

const formatValue = (value: any, field: any) => {
  if (field.format) {
    switch (field.format) {
      case 'date':
        return formatDateWithYear(value)
      case 'date-time':
        return formatDateTime(value)
      default:
        return value
    }
  }
  return value
}

return { __sfc: true,props, schema, uiSchema, customFields, locationHasCustomData, formatValue }
}

})